// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sc-popup-main {
  position: absolute !important;
  width: 150% !important; }
  .sc-popup-main .sc-popup-name {
    margin: 7px;
    font-size: 1.5em;
    color: #42BCE1;
    display: flex;
    justify-content: center; }
  .sc-popup-main .mapboxgl-popup-content {
    background-color: #18244c;
    color: white; }
  .sc-popup-main .popup-container-left {
    opacity: 0.95;
    text-align: left;
    padding-top: 2px;
    margin-bottom: 22px;
    padding-left: 4px;
    padding-right: 4px;
    font-size: 14px;
    min-width: 300px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column;
    line-height: 10px; }
    .sc-popup-main .popup-container-left .GD-p-comid {
      margin-bottom: 0px;
      padding-bottom: 7px; }

.popup-wrapper .mapboxgl-popup-content {
  width: 150% !important; }

.popup-wrapper .popup-context-menu-render-popup {
  text-align: left;
  border-radius: 4px;
  width: 160px !important;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  width: 100%;
  overflow: hidden;
  background-color: white; }
  .popup-wrapper .popup-context-menu-render-popup ul {
    list-style: none;
    margin-left: "-1rem";
    margin-bottom: 0;
    padding: 6px; }
  .popup-wrapper .popup-context-menu-render-popup .context-container-render-popup {
    margin-left: "-1rem"; }
  .popup-wrapper .popup-context-menu-render-popup .popup-context-item-render-popup {
    text-decoration: none !important;
    padding: 4px; }
  .popup-wrapper .popup-context-menu-render-popup .popup-hover-render-popup:hover {
    background-color: rgba(43, 10, 230, 0.261); }
  .popup-wrapper .popup-context-menu-render-popup .results-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center; }

.popup-list {
  margin-left: 2rem; }

.h303 {
  max-width: unset !important;
  width: 300px !important; }
`, "",{"version":3,"sources":["webpack://./src/components/render-popup.scss"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sBAAsB,EAAA;EAFxB;IAKI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB,EAAA;EAT3B;IAaI,yBAAyB;IACzB,YAAY,EAAA;EAdhB;IAkBI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,iBAAiB,EAAA;IA7BrB;MAgCM,kBAAkB;MAClB,mBAAmB,EAAA;;AAKzB;EAEI,sBAAsB,EAAA;;AAF1B;EAKI,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB,EAAA;EAZ3B;IAcM,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY,EAAA;EAjBlB;IAoBM,oBAAoB,EAAA;EApB1B;IAuBM,gCAAgC;IAEhC,YAAY,EAAA;EAzBlB;IA6BQ,0CAA0C,EAAA;EA7BlD;IAkCM,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;;AAKzB;EACE,iBAAiB,EAAA;;AAGnB;EACE,2BAA2B;EAC3B,uBAAuB,EAAA","sourcesContent":[".sc-popup-main {\n  position: absolute !important;\n  width: 150% !important;\n\n  .sc-popup-name {\n    margin: 7px;\n    font-size: 1.5em;\n    color: #42BCE1;\n    display: flex;\n    justify-content: center;\n  }\n\n  .mapboxgl-popup-content { \n    background-color: #18244c;\n    color: white;\n  }\n\n .popup-container-left { \n    opacity: 0.95;\n    text-align: left; \n    padding-top: 2px;\n    margin-bottom: 22px;\n    padding-left: 4px;\n    padding-right: 4px;\n    font-size: 14px;\n    min-width: 300px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n    line-height: 10px;\n\n    .GD-p-comid {\n      margin-bottom: 0px;\n      padding-bottom: 7px;\n    }\n  }\n}\n\n.popup-wrapper {\n  .mapboxgl-popup-content {\n    width: 150% !important;\n  }\n  .popup-context-menu-render-popup {\n    text-align: left;\n    border-radius: 4px;\n    width: 160px !important;\n    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    width: 100%;\n    overflow: hidden;\n    background-color: white;\n    ul {\n      list-style: none;\n      margin-left: \"-1rem\";\n      margin-bottom: 0;\n      padding: 6px;\n    }\n    .context-container-render-popup {\n      margin-left: \"-1rem\";\n    }\n    .popup-context-item-render-popup {\n      text-decoration: none !important;\n\n      padding: 4px;\n    }\n    .popup-hover-render-popup {\n      &:hover {\n        background-color: rgba(43, 10, 230, 0.261);\n      }\n    }\n\n    .results-wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n}\n\n.popup-list {\n  margin-left: 2rem;\n}\n\n.h303 {\n  max-width: unset !important;\n  width: 300px !important;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
